import * as C from '../../../i18n/constants';
import { registerCondition, getCondition } from '../conditionRegisterer';
import { CONDITION_NAME as CONDITION_CONTAINS } from './contains';
export var CONDITION_NAME = 'not_contains';
export function condition(dataRow, inputValues) {
  return !getCondition(CONDITION_CONTAINS, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME, condition, {
  name: C.FILTERS_CONDITIONS_NOT_CONTAIN,
  inputsCount: 1,
  showOperators: true
});


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/filters/condition/notContains.js
// module id = 7LRr
// module chunks = 0